import { UserConsent, performance } from "cookiesConsent/domain/consent"
import { Analytics } from "cookiesConsent/domain/analytics"
import { Visitor } from "cookiesConsent/domain/visitor"

export interface ConsentSource {
  read: () => UserConsent
}

export class ConsentGatedAnalytics implements Analytics {
  private readonly analytics: Analytics
  private readonly consent: ConsentSource

  constructor(analytics: Analytics, consent: ConsentSource) {
    this.analytics = analytics
    this.consent = consent
  }

  identify = (visitor: Visitor): void => {
    if (this.consent.read().permits(performance)) {
      this.analytics.identify(visitor)
    } else {
      this.withhold()
    }
  }

  remembersCustomer = (): boolean => this.analytics.remembersCustomer()

  forget = (): void => {
    this.analytics.forget()
  }

  private withhold = (): void => {}
}
